// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__14h0a","choiceBoxes":"toolbarselects_choiceBoxes__z51N_","simpleField":"toolbarselects_simpleField__2PDEL"};